import produce from 'immer';
import { IPaginatedStoreResource } from '../helpers/pagination';
import { initialRootState } from '../initialRootState';
import { EVisitsActionType, IVisitsAction } from './actions';

interface IVisitsStore extends IPaginatedStoreResource {
  list: string[];
}
export interface IVisitsState {
  received: IVisitsStore;
}

export const visitsReducer = (
  currentState: IVisitsState = initialRootState.visits,
  action: IVisitsAction
): IVisitsState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EVisitsActionType.GET_VISITS_SUCCESS:
        const {
          meta: {
            pagination: { current_page: currentPage, total },
          },
          data,
        } = action.payload.result;

        draft.received.list = draft.received.list.concat(data);
        draft.received.meta = { currentPage, total };

        break;
      case EVisitsActionType.RESET:
        draft.received = initialRootState.visits.received;
        break;
    }
  });
